import { makeStyles } from 'e100-react-components';

import type { ButtonProps } from './ui';

interface Props extends Pick<
  ButtonProps,
  'mobileButton' | 'variant'
> {}

export const useStyles = makeStyles(({
  spacing,
  palette
}) => ({
  root: ({ mobileButton, variant }: Props) => ({
    ...mobileButton && {
      minWidth: 40,
      padding: spacing()
    },
    ...variant === 'filled' && {
      backgroundColor: palette.primary.light,
      color: palette.primary.main
    },
    '&:hover': {
      background: palette.background.default
    }
  }),

}));
